/**
 *
 * ResumeControlPresens
 *
 */

import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { List, Empty, Button } from 'antd';

// icons
import CustomIcons from 'components/CustomIcons';

// utils
import { getExcusedAbsences, generateAbsenceReason } from 'utils/helpers/helper.generateData';
import { getObjId } from 'utils/helpers/helper.general';

function ResumeControlPresens({
  // states
  formData,
  course,
  currentStep,
  controlType,
  // actoins
  prevStep,
  nextStep,
  goToStep,
  result,
  // default props
  className,
}) {
  const childClassNames = classNames('resume-control-presens', className);

  const goToPrev = () => {
    if (controlType == 'all') {
      goToStep(1);
    } else {
      prevStep !== undefined && prevStep();
    }
  };

  const onConfirm = () => {
    result();
    nextStep !== undefined && nextStep();
  };

  const stdReason = useCallback((absData) => generateAbsenceReason(absData), []);

  return (
    <div className={childClassNames}>
      <List
        className="list-absence-student"
        dataSource={formData?.missing_students || []}
        renderItem={item => {
          const absArr = getExcusedAbsences(
            formData?.missing_students,
            formData?.date,
            course,
          );
          const arr =  absArr.length > 0 ? absArr : item?.hasAbs || [];
          let abs = arr.length > 0 ? arr[0] : false;
            const hasSickness = arr?.filter(absence => absence?.status == 'sick') || [];
          if (hasSickness) {
            abs = hasSickness[0];
          }
          const reason = abs && getObjId(item) == getObjId(abs?.student) && stdReason(abs);
          return (
            <List.Item key={item?._id + '-excused-resume'}>
              <CustomIcons type="person" />
              <List.Item.Meta
                title={`${item?.description?.lastname} ${
                  item?.description?.firstname
                }`}
                description={reason}
              />
            </List.Item>
          );
        }}
        locale={{
          emptyText: <Empty description="Aucun élève absent." />,
        }}
      />
      <div className="control-actions-wrapper">
        <Button className="btn-previous" onClick={goToPrev}>
          Retour
        </Button>
        <Button className="confirm-btn" onClick={onConfirm}>
          Confirmer
        </Button>
      </div>
    </div>
  );
}

ResumeControlPresens.defaultProps = {};
ResumeControlPresens.propTypes = {};

export default memo(ResumeControlPresens);
